import { addBreadcrumb } from '@sentry/react'
import { isArray } from 'lodash-es'
import { call, select, takeEvery } from 'typed-redux-saga'
import type { Action, AnyAction, ErrorAction } from '~/actions'
import type { State } from '~/types'
import { captureError } from '~/utils'

export function* reportingSagas() {
	yield* takeEvery((a: AnyAction) => a.type.endsWith('ERROR'), logError)
	yield* takeEvery((a: AnyAction) => !a.type.endsWith('ERROR') && a.type.includes('CART'), logAction)
}

function* logError(action: ErrorAction) {
	const { meta } = action
	if (meta === undefined) return
	const errors = isArray(meta) ? meta : [meta]

	for (const error of errors) {
		console.warn(error.message, error)
		yield captureError(error)
	}
}

export function* logAction(action: Action) {
	const cart = yield* select((s: State) => s.cart)
	if (!cart.loaded || action.type === 'CART_OPEN') return

	yield* call(addBreadcrumb, {
		category: action.type.split('_')[0]?.toLowerCase() || 'unknown',
		message: action.type,
		level: 'info',
		data: action
	})
}
